// Google Analytics 4 — skrypt jest ładowany wyłącznie po zgodzie na cookies analityczne.
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-Q6TBRW68FL";

const CONSENT_KEY = "nexxsite-cookie-consent"; // "granted" | "denied"; zapamiętana decyzja to zapis niezbędny
export const CONSENT_EVENT = "nexxsite:consent";
export const OPEN_CONSENT_EVENT = "nexxsite:open-consent";

let loaded = false;
let conversionListenerAttached = false;
let lastPageView = null;
let sessionConsent = null;

export function getConsent() {
  try {
    const value = window.localStorage.getItem(CONSENT_KEY);
    if (value === "granted" || value === "denied") return value;
    return sessionConsent;
  } catch {
    return sessionConsent;
  }
}

export function setConsent(value) {
  sessionConsent = value;
  try { window.localStorage.setItem(CONSENT_KEY, value); } catch { /* prywatne okno: decyzja tylko na tę wizytę */ }
  if (value === "granted") loadAnalytics();
  else revokeAnalytics();
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
}

// Polecenia Consent Mode muszą trafić do dataLayer jako obiekt `arguments` (tak jak robi to gtag()).
function consentCommand() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

function attachConversionListener() {
  if (conversionListenerAttached) return;
  window.addEventListener("nexxsite:conversion", onConversion);
  conversionListenerAttached = true;
}

/** Wstrzykuje GA4 po zgodzie i przekazuje do dataLayer zdarzenia konwersji ze strony. */
export function loadAnalytics() {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID || getConsent() !== "granted") return;
  if (loaded) {
    consentCommand("consent", "update", { analytics_storage: "granted" });
    attachConversionListener();
    trackPageView();
    return;
  }

  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  // Baner pyta tylko o analitykę: zgody reklamowe zostają odrzucone.
  consentCommand("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "granted" });
  consentCommand("js", new Date());
  consentCommand("config", GA_MEASUREMENT_ID, { send_page_view: false });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  document.head.appendChild(script);
  attachConversionListener();
  trackPageView();
}

export function trackPageView() {
  if (!loaded || typeof window === "undefined" || getConsent() !== "granted") return;
  const pageLocation = window.location.href;
  if (pageLocation === lastPageView) return;
  lastPageView = pageLocation;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: pageLocation,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
}

function onConversion(event) {
  const { event: name, services = [] } = event.detail || {};
  if (!name) return;
  // conversionEvents.js nie przekazuje danych formularza ani kontaktowych — tylko nazwę zdarzenia i usługi.
  window.dataLayer.push({ event: name, services: services.join(",") });
}

/** Wycofanie zgody: tagi Google przestają zapisywać cookies, a istniejące cookies _ga są usuwane. */
function revokeAnalytics() {
  if (loaded) consentCommand("consent", "update", { analytics_storage: "denied" });
  if (conversionListenerAttached) {
    window.removeEventListener("nexxsite:conversion", onConversion);
    conversionListenerAttached = false;
  }
  lastPageView = null;
  const host = window.location.hostname.replace(/^www\./, "");
  for (const cookie of document.cookie.split(";")) {
    const name = cookie.split("=")[0].trim();
    if (!name.startsWith("_ga")) continue;
    for (const domain of ["", `; domain=${host}`, `; domain=.${host}`]) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`;
    }
  }
}
